module.exports = __webpack_public_path__ + "static/media/dicom_demo_1.5418175e.zip";